import { FC } from 'react';

import { Column, Container, StyledHeader } from './SamplesSequencedInfo.style';
import { SamplesSequencedInfoProps } from './SamplesSequenced.types';
import { Sizes, Weights } from '@/common/types';
import { NumberText } from '@/common/components';

const SamplesSequencedInfo: FC<SamplesSequencedInfoProps> = ({ title, total }) => {
  return (
    <Container>
      <Column>
        <StyledHeader data-testid="sample-sequenced-info-title">{title}</StyledHeader>
        <NumberText testId="sample-sequenced-info-total" size={Sizes.LARGE} weight={Weights.EXTRA_BOLD}>
          {total}
        </NumberText>
      </Column>
    </Container>
  );
};

export default SamplesSequencedInfo;
